import React from "react";

/** Admin pages use sidebar footer only — no page-level copyright bar. */
export default function Footer() {
  return null;
}
